module.exports = __webpack_public_path__ + "static/img/wlxkz.3081c0ed.jpg";